export const AP_SRP_LOADER = {
  desktop: `
<div class="cui cui-grid cui-container">
  <div class="cui-skeleton-heading -size--large -spacing--top-64">
    <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description -spacing--top-24" style="height: 20px"></div>
    </div>
  </div>
  <div class="cui-row -spacing--top-16 -spacing--bottom-120">
    <div class="cui-col -spacing--top-24 -spacing--right-40" style="max-width: 18rem">
      <div class="cui-skeleton-paragraph">
        <div class="cui-skeleton-paragraph__content" style="width: 100%">
          <div class="cui-skeleton__item cui-skeleton__description" style="width: 140px; height: 1rem"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph -spacing--top-32">
        <div class="cui-skeleton-paragraph__content" style="width: 100%">
          <div class="cui-skeleton__item cui-skeleton__description" style="width: 140px; height: 1rem"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-32">
        <div class="cui-skeleton__item" style="width: 100%; height: 240px"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-32">
        <div class="cui-skeleton__item" style="width: 100%; height: 184px"></div>
      </div>
    </div>
    <div class="cui-col" style="min-width: min(30rem,100%)">
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24 -spacing--bottom-40">
        <div class="cui-skeleton__item" style="height: 48px; width: min(540px, 100%)"></div>
      </div>
      <div class="cui-skeleton-paragraph -spacing--top-16 -spacing--bottom-24">
        <div class="cui-skeleton-paragraph__content" style="width: 100%">
          <div class="cui-skeleton__item cui-skeleton__description" style="width: 200px; height: 27px"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 7.5rem"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-48">
        <div class="cui-skeleton__item" style="width: 100%; height: 32px"></div>
      </div>
    </div>
  </div>
</div>
`,
  mobile: `
<div class="cui cui-grid cui-container">
  <div class="-spacing--bottom-64">
    <div class="cui-skeleton-heading -size--large -spacing--top-24">
      <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
        <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 200px; height: 36px"></div>
        <div class="cui-skeleton-paragraph -spacing--top-16">
          <div class="cui-skeleton-paragraph__content" style="width: 100%">
            <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
            <div class="cui-skeleton__item cui-skeleton__description -spacing--top-8" style="height: 1rem"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="-spacing--top-24 -spacing--bottom-24">
      <div style="width: 100%">
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 489px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-40">
          <div class="cui-skeleton__item" style="width: 100%; height: 74px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-40">
          <div class="cui-skeleton__item" style="width: 100%; height: 246px"></div>
        </div>
        <div class="cui-skeleton-heading -size--large -spacing--top-32">
          <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
            <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 200px; height: 36px"></div>
            <div class="cui-skeleton-paragraph -spacing--top-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%">
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-32">
          <div class="cui-skeleton__item" style="width: 100%; height: 160px"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`
};
